














import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  name: "SgsVersion"
})
export default class SgsVersion extends Vue {  
  private updateExists = false;
  private refreshing = false;
  private registration: any = null;    
  private snackWithButtons = false;
  private timeout = -1;

  private mounted() {  
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
      console.log("Refresh completed");
    });
  }

  private beforeDestroy() {
    document.removeEventListener("swUpdated", this.showRefreshUI);
  }

  private showRefreshUI(e: any) {
    // My code to show the refresh UI banner/snackbar goes here.
    console.log("Updating");
    this.updateExists = true;
    this.registration = e.detail;
    this.snackWithButtons = true;
  }

  private refreshApp() {
    this.updateExists = false;
    if (!this.registration || !this.registration.waiting) {
      return;
    }
    this.registration.waiting.postMessage("skipWaiting");
  }
}

Vue.component('sgs-version', SgsVersion);
